import moment from 'moment-timezone';
import { call, put, takeEvery } from 'redux-saga/effects';
import { completeLocaleChange, futureLocaleChange, setFutureSendLoading } from './futureSendModule';
import { momentLocaleImport } from '../utils/time/momentUtils';
import { SET_LOCALE, INITIALIZE_LOCALE } from '../intl/intlModule';


export function* updateCalendarLocale({ locale }) {
    yield put(setFutureSendLoading(true));
    yield call(momentLocaleImport, locale);
    yield call(moment.locale, locale);
    
    
    yield put(futureLocaleChange(locale));
    yield put(setFutureSendLoading(false));
    yield put(completeLocaleChange());
}


export function* futureSendSagasWatcher() {
    
    yield takeEvery(SET_LOCALE, updateCalendarLocale);
    
    yield takeEvery(INITIALIZE_LOCALE, updateCalendarLocale);
}
